import { formatSelectOptions } from '@/utils/util';
import { CommonEnumKey } from '@/utils/enum';
export const getFormData = () => {
  const { enumTranslator } = store?.getState() || {};
  // 获取枚举值
  // 事故等级枚举
  const accidentLevelList = formatSelectOptions(
    enumTranslator?.[CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM]
  );
  // 事故分类枚举
  const accidentTypeList = formatSelectOptions(
    enumTranslator?.[CommonEnumKey.THOROUGH_ACCIDENT_TYPE_ENUM]
  );
  // 有无责任枚举
  const technicalSupportResponsibleList = formatSelectOptions(
    enumTranslator?.[CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM]
  );
  // 严重程度枚举
  const severityList = formatSelectOptions(
    enumTranslator?.[CommonEnumKey.BUG_SEVERITY_ENUM]
  );

  // 构造表单数据
  const FormData: FormConfig = {
    data: [
      {
        label: '问题标题',
        fieldName: 'topic',
        cmpType: 'input',
        placeholder: '请输入问题标题',
        validatorRules: [
          {
            required: true,
            message: '请输入问题标题',
          },
        ],
      },
      {
        label: '严重程度',
        fieldName: 'severity',
        validatorRules: [
          {
            required: true,
            message: '请选择严重程度',
          },
        ],
        placeholder: '请选择严重程度',
        cmpType: 'select',
        data: severityList,
      },
      {
        label: '是否为碰撞/剐蹭',
        fieldName: 'isCrash',
        validatorRules: [
          {
            required: true,
            message: '必选项',
          },
        ],
        cmpType: 'radioGroup',
        data: [
          {
            label: '是',
            value: '1',
          },
          {
            label: '否',
            value: '0',
          },
        ],
      },
      {
        label: '有无责任',
        fieldName: 'technicalSupportResponsible',
        validatorRules: [
          {
            required: true,
            message: '请选择有无责任',
          },
        ],
        hidden: true,
        data: technicalSupportResponsibleList,
        cmpType: 'select',
        placeholder: '请选择有无责任',
      },
      {
        label: '事故等级',
        fieldName: 'accidentLevel',
        validatorRules: [
          {
            required: true,
            message: '请选择事故等级',
          },
        ],
        placeholder: '请选择事故等级',
        cmpType: 'select',
        data: accidentLevelList,
        hidden: true,
      },
      {
        label: '事故分类',
        fieldName: 'accidentType',
        validatorRules: [
          {
            required: true,
            message: '请选择事故分类',
          },
        ],
        hidden: true,
        cmpType: 'select',
        data: accidentTypeList,
        placeholder: '请选择事故分类',
      },
      {
        label: '事故负责人',
        fieldName: 'follower',
        validatorRules: [
          {
            required: true,
            message: '请输入erp',
          },
        ],
        placeholder: '请输入erp',
        cmpType: 'input',
        hidden: true,
      },
      {
        label: '问题描述',
        fieldName: 'description',
        validatorRules: [
          {
            required: true,
            message: '请输入问题描述',
          },
        ],
        cmpType: 'textarea',
        placeholder: '请输入问题描述',
        maxLength: 200,
      },
      {
        label: 'Rover版本',
        fieldName: 'version',
        validatorRules: [
          {
            required: true,
            message: '请选择Rover版本',
          },
        ],
        placeholder: '请选择Rover版本',
        cmpType: 'select',
      },
      {
        label: '发生时间',
        fieldName: 'debugTime',
        validatorRules: [
          {
            required: true,
            message: '请选择发生时间',
          },
        ],
        placeholder: '请选择发生时间',
        cmpType: 'custom',
      },
      {
        label: '上传截图',
        fieldName: 'attachment',
        cmpType: 'upload',
      },
    ],
    linkRules: [
      {
        fieldName: 'isCrash',
        linkFieldName: 'accidentLevel',
        type: ['visible'],
        visibleRule: {
          show: ['1'],
        },
      },
      {
        fieldName: 'isCrash',
        linkFieldName: 'technicalSupportResponsible',
        type: ['visible'],
        visibleRule: {
          show: ['1'],
        },
      },
      {
        fieldName: 'isCrash',
        linkFieldName: 'accidentType',
        type: ['visible'],
        visibleRule: {
          show: ['1'],
        },
      },
      {
        fieldName: 'isCrash',
        linkFieldName: 'follower',
        type: ['visible'],
        visibleRule: {
          show: ['1'],
        },
      },
    ],
  };
  return FormData;
};
